import { routerReducer as routing } from 'react-router-redux';

import { branch } from './dealer/account/Branch/reducer';
import { dealersInsights } from './dealer/shared/modules/dealersInsights/redux/reducer';
import { terms } from './dealer/account/Terms/reducer';
import { billing, invoicesFilter } from './dealer/account/Billing/reducer';
import { branches } from './dealer/account/Branches/reducer';
import { dashboard } from './dealer/dashboard/reducer';
import { listings, listingsFilters } from './dealer/listings/reducer';
import { closedLeads } from './dealer/leads/ClosedLeads/reducer';
import { openLeads } from './dealer/leads/OpenLeads/reducer';
import { contentful } from './dealer/shared/modules/contentful/reducer';
import { lead } from './dealer/leads/Lead/reducer';
import { paymentMethod } from './dealer/account/PaymentMethod/reducer';
import { requestInvite } from './dealer/requestinvite/reducer';
import { authorities } from './dealer/shared/modules/authorities/reducer';
import { globalEvents } from './shared/modules/globalEvents/reducer';
import { service } from './dealer/service/reducer';
import { pageTemplate } from './shared/modules/pageTemplate/reducer';
import { leads } from './dealer/leads/Leads/reducer';
import { overlay } from './shared/modules/overlay/reducer';
import { leadPreferences } from './dealer/account/Settings/reducer';
import { dealerProfileSettings } from './dealer/account/DealerProfileSettings/reducer';

export const memoryStorageReducers = {
  authorities,
  routing,
  dealersInsights,
  terms,
  billing,
  invoicesFilter,
  branches,
  branch,
  dashboard,
  leadPreferences,
  dealerProfileSettings,
  //  Oh leads lead us to the money
  leads,
  listings,
  listingsFilters,
  closedLeads,
  openLeads,
  lead,
  paymentMethod,
  requestInvite,
  globalEvents,
  service,
  pageTemplate,
  overlay,
  contentful,
};
